module.exports = __webpack_public_path__ + "media/images/riders/JAROSLAV_KULHAVY-fdbd2a1d4601cb29f430754b56c1590f.png";